import { Helmet } from "react-helmet-async"
import { LeadChannelsList } from "../../../../LeadChannels"

export default function OrganizationLeadChannelsPage() {
	return (
		<>
			<Helmet>
				<title>Lead Channels</title>
			</Helmet>
			<LeadChannelsList />
		</>
	)
}
